import React from 'react'

const Adminboxes = (props) => {
  return (
    <div style={{width:"200px",minHeight:"370px",textAlign:"center",background:"rgb(14,66,90,.3)",color:"white"}}>
        <div style={{background:"rgb(14,66,90)"}}>{props.header}</div>{props.children}</div>
  )
}

export default Adminboxes